
import React , { useState, useRef, useEffect } from 'react';
import app from "./app" 
import {ActionWrap, GridWrap, ListWrap, Elements} from "./helpers" 


const showPopup = (event) => { 
  event.preventDefault(); 
  if (event.currentTarget.classList.contains("others")) {
    document.querySelector("body").classList.add("show-popup");
  } else {
    document.querySelector("body").classList.remove("show-popup"); 
  }
}; 

const showLocationPopup = (event)  => {
  
  event.preventDefault();  
  const popups = document.querySelector('.locationAiPopup');
  
  
  let el = event.currentTarget;
  if (el.classList.contains("on")) {
      el.classList.remove("on");
      popups.style.display = "none";
  }
  else {
      el.classList.add("on");
      popups.style.display = "block";
  }
  event.stopPropagation();
}

const MenuPopup = (props) => {
  const [searchTerm, setSearchTerm] = useState([]); 
  const handleSearchChange = (e) => { 
    setSearchTerm(e.target.value.toLowerCase())
  };
  

useEffect(()=>{
  if(app.getMode(props.mode)){ 
    const popup = document.querySelector("#morePagesbuilder"); 
    // popup.addEventListener("click", function(e){
    //   if(e.target.tagName.toLowerCase() === 'a'){
    //     document.querySelector("body").classList.remove("show-popup");
    //     document.querySelectorAll(".other input").forEach(function (v) {
    //       v.value = "";
    //     }); 
    //   }
    // })
  }  
},[props.home ,props.showPopup])


useEffect(()=>{ 
  document.body.addEventListener('click', function(event) {
      const popups = document.querySelectorAll('.popupAiWrapper');
      popups.forEach(box => {

      // console.log("box.contains(event.target)", box.contains(event.target), event.target)
        if (!box.contains(event.target)) {
          if (box.classList.contains('on') || box.classList.contains('show')) {
              box.classList.remove('on');
              box.classList.remove('show');
          }
      }
      });
  });
},[])
  
  return <div className="modal pages-modal show" id="morePagesbuilder" aria-modal="true" role="dialog" >
  
  <div className="modal-dialog modal-lg modal-dialog-centered" id="other">
      <div className="modal-content rounded-0" style={{background:app.elementBackground(props.data.properties.backgroundWeb, props.data.properties.backgroundWebType, props.data.properties.overlayColorWeb)}}>
      {/* Modal Header */}
      <div className="modal-header border-bottom-0 pb-0">
          <h4 className="modal-title fs-5">Others</h4>
          <button type="button" className="btn-close icon-cancel" onClick={(e)=>props.showPopup(e)}></button>
      </div>
      {/* Modal body */}
      <div className="modal-body">

        <div className="input-group mb-3 menuSearchBox"> 
          <input type="text" className="form-control bg-transparent" value={searchTerm} onChange={handleSearchChange} placeholder={app.getLang("searchHere")} style={{height: '46px', border: '0',boxShadow: 'none'}}/>
          <span className="input-group-text icon-search-3" style={{height: '46px', border: '0', background: '#00000012', cursor:'pointer'}}></span>
        </div>

        <ul className="list-group list-group-horizontal flex-wrap max-vh-50 page-scroll all-category">
              {/* {
                  props.home.map(function (v, i) { 
                      return <li className="list-group-item w-25 border-0" title={v.pageName} alt={v.pageName} key={'h-' + i} style={{background: 'transparent', display:v.pageNewid?v.pageNewid.toLowerCase().includes(searchTerm) || searchTerm === ""? "block": "none":v.pageName.toLowerCase().includes(searchTerm) || searchTerm === ""? "block": "none"}}>
                         <a href={`/${v.pageUrl}`} onClick={(e) => window.routerClick(e)} data-index={i}>{v.pageNewid?v.pageNewid:v.pageName}</a>
                      </li>
                  })
              } */}
          </ul>
      </div>
      </div>
  </div>
  </div>


}
const string2parse = function(data) { 
  if (typeof data === 'string') {
      try {
          return JSON.parse(data); 
      } catch (e) {
          console.error('Invalid JSON string:', e);
          return data; 
      }
  }

  // If data is already parsed (not a string), return it as-is
  return data;
}

export const HeaderAi = function(props) {  
  const data = string2parse(props.data) 
    const {index, widgetType, mode, device, headerValue, loginValue, cartValue, notificationValue, locationValue, appData, page} = props;  
    
    const [pages, setPages] = useState([]);
    const [socialWidth, setSocialWidth] = useState([0]);
    const [hamburgerWidth, setHamburgerWidth] = useState([0]); 
    const [scroll, setScroll] = useState(0);
    const [prevScroll, setPrevScroll] = useState(0);
    const [headerHeight, setHeaderHeight] = useState(null);
    const [domWin, setDomWin] = useState(null);
    const [iframeWindow, setIframeWindow] = useState(null);
    const [type, setType] = useState(null);
    // const [bodyWidth, setBodyWidth] = useState(null); 
 
  const searchMobileMenu = (event) => { 
    let text = event.currentTarget.value.trim().toLowerCase();  
      if (text === "") {
        document.querySelectorAll("#navigation li").forEach(function (v) {
            v.classList.remove("d-none")
        })
        return false;
    }
    document.querySelectorAll("#navigation li").forEach(function (v) {
        if (v.innerText.toLowerCase().indexOf(text) === -1) {
            v.classList.add("d-none")
        }
        else {
            v.classList.remove("d-none")
        }
    })
  } 
      
  const getDomWin = () =>{
    let domEle = document;
    if (app.getMode(mode)) {
      if (document.querySelector(".appHeaderAi .app-container")) {
        domEle = document.querySelector(".appHeaderAi .app-container");
      } else if (document.querySelector(".all-widgets .headerAi")) {
        domEle = document.querySelector(".all-widgets");
      }
      setIframeWindow(window);
    } else {
      if (document.querySelector("#iframe")) {
        if (document.querySelector("#iframe").contentWindow) {
          domEle = document.querySelector("#iframe").contentWindow.document;
          setIframeWindow(document.querySelector("#iframe").contentWindow);
        }
      }
    }
    setDomWin(domEle);
    
  
    if (domWin) {
      if (domWin.querySelector('[widget-type="headerAi"]')) {
        let header = domWin.querySelector('[widget-type="headerAi"]').offsetHeight;
        setHeaderHeight(header); 
      }
    } 
  }
  
  useEffect(() => {
    getDomWin()
  }, [data, index, widgetType, mode, device, headerValue, loginValue, cartValue, notificationValue, locationValue, appData, page]);




  useEffect(() => { 
    // scroll_back Header function 
     if (domWin) {   
        let routerNavs = ""; 
        if(domWin.querySelector('#router-navs')){
          routerNavs = domWin.querySelector('#router-navs').offsetHeight;
        } 
       
        if(app.getMode(mode) && data.properties.fixedPosition && data.properties.fixedHeaderStyle === "basic"){
          let headerBar = domWin.querySelector('[widget-type="headerAi"]'); 
          headerBar.classList.add("basic");
          let header = headerBar.offsetHeight; 
          if(domWin.querySelector('.page_body') && props.mode === "edit"){
            domWin.querySelector('.page_body').style.paddingTop = header+'px';
          } 
          if(domWin.querySelector(".page-view .all-widgets") && props.mode === "priview"){
            domWin.querySelector('.page-view .all-widgets').style.paddingTop = header+'px';
          }  
          if(domWin.querySelector(".appHeaderAi .app-content") && props.mode === "live"){
            if(domWin.querySelector('#router-navs')){
              domWin.querySelector('#router-navs').style.top = headerBar.offsetHeight+6+'px';
            }  
            domWin.querySelector(".appHeaderAi .app-content").style.paddingTop = header+routerNavs+'px';
          } 
        } 
        if(app.getMode(mode) && data.properties.fixedPosition && data.properties.fixedHeaderStyle === "scroll_back"){
          let headerBar = domWin.querySelector('[widget-type="headerAi"]'); 
          headerBar.classList.add("scroll_back");
          let header = headerBar.offsetHeight; 

          // domWin.querySelector('[widget-type="headerAi"]').classList.add("scroll_back")
          // let header = domWin.querySelector('[widget-type="headerAi"]').offsetHeight; 
          
          if(domWin.querySelector('.page_body') && props.mode === "edit"){
            domWin.querySelector('.page_body').style.paddingTop = header+'px';
          } 
          if(domWin.querySelector(".page-view .all-widgets") && props.mode === "priview"){
            domWin.querySelector('.page-view .all-widgets').style.paddingTop = header+'px';
          } 
          if(domWin.querySelector(".appHeaderAi .app-content") && props.mode === "live"){
            if(domWin.querySelector('#router-navs')){
              domWin.querySelector('#router-navs').style.top = headerBar.offsetHeight+'px';
            } 
            domWin.querySelector(".appHeaderAi .app-content").style.paddingTop = header+routerNavs+'px';
          }
          domWin.addEventListener('scroll', handleScroll); 
          domWin.addEventListener('resize', updateHeaderHeight); 

          return () => {
            domWin.removeEventListener('scroll', handleScroll);
            domWin.removeEventListener('resize', updateHeaderHeight);
          };
        }
        else{
          if(!data.properties.fixedPosition){
            if(domWin.querySelector('#router-navs')){
              domWin.querySelector('#router-navs').classList.add("position-static")
            } 
          }
          
        }
 
    } 
  }, [domWin, prevScroll, headerHeight]);


  const handleScroll = () => { 
    const scrolled = domWin.scrollTop; 
    setScroll(scrolled);
    if (scrolled > headerHeight && scrolled < prevScroll) { 
      // console.log("document", document)
       if(domWin.querySelector('[widget-type="headerAi"]')){
        document.body.classList.remove('headerAi-scroll-back');
        domWin.querySelector('[widget-type="headerAi"]').classList.add('header-scroll');
        domWin.querySelector('[widget-type="headerAi"]').classList.add('header-scroll')
        domWin.querySelector('[widget-type="headerAi"]').classList.add('position-fixed')
        domWin.querySelector('[widget-type="headerAi"]').classList.remove('header-up')
      }  
    } 
    else { 
      if(domWin.querySelector('[widget-type="headerAi"]')){
        // console.log("document2", document)
        document.body.classList.add('headerAi-scroll-back');
        domWin.querySelector('[widget-type="headerAi"]').classList.add('header-up')
        domWin.querySelector('[widget-type="headerAi"]').classList.remove('header-scroll')
        domWin.querySelector('[widget-type="headerAi"]').classList.remove('position-fixed')
        if (scrolled < 70){
          document.body.classList.remove('headerAi-scroll-back');
          domWin.querySelector('[widget-type="headerAi"]').classList.remove('header-up')
        }
      }
    } 
    setPrevScroll(scrolled);
  };

  const updateHeaderHeight = () => {
      if(domWin.querySelector('[widget-type="headerAi"]')){
          let header = domWin.querySelector('[widget-type="headerAi"]').offsetHeight;
          setHeaderHeight(header); 
      } 
  }; 
   

  useEffect(() => { 
    if (domWin && device === "desktop") {
      // console.log("domWin", domWin)
      let dom = domWin;
      if(props.mode === "live" || props.mode === "preview"){
        dom = window.document;
      } 
         
        if(dom.getElementById("headerSocialInfo")){
            setTimeout(() => {
              let d = dom.getElementById("headerSocialInfo");
              let cs = getComputedStyle(d);
              let w = d.getBoundingClientRect().width + parseFloat(cs.getPropertyValue('margin-left')) + parseFloat(cs.getPropertyValue('margin-right'))
              setSocialWidth(w); 
            },10)
        }
        if(dom.getElementById("openbtn")){
            let z = dom.getElementById("openbtn").offsetWidth;
            setHamburgerWidth(z);
        }  
   
        var items = dom.querySelectorAll('#navigation li.nav-item');  
        items.forEach(function(item) { 
            item.addEventListener('click', function(event) { 
                //event.preventDefault();  
                items.forEach(function(item) {
                    item.classList.remove('on');
                });  
                this.classList.add('on');
            });
        }); 
    }
  }, [domWin, data, device]);


  useEffect(() => {  
    setPages(localStorage.getItem("pages")?JSON.parse(localStorage.getItem("pages")):[]);
    adjustMenu();
    
  }, []);

  useEffect(() => {
    if(domWin){
      adjustMenu();
      //window.addEventListener('resize', adjustMenu);
      //return () => window.removeEventListener('resize', adjustMenu);
    }
  },[domWin,headerHeight,pages,data,props.data]);

  // set document body width on change 
  useEffect(() => {
    if(iframeWindow) {
      adjustMenu();
      iframeWindow.addEventListener('resize', adjustMenu);
    }
  }, [iframeWindow]);
  
  const adjustMenu = function(){  
    return false;
    //console.log("adjustMenu");
    if(!domWin){
      return;
    } 
    
    if(device === "mobile") {
      return false;
    }

    if(domWin.querySelector('[widget-type="headerAi"] .navbar-nav')) {
      const menu = domWin.querySelector('[widget-type="headerAi"] .navbar-nav');
      const othersDropdown = domWin.querySelector('[widget-type="headerAi"] #othersDropdown');
      const othersMenu = domWin.querySelector('[widget-type="headerAi"] #othersMenu');
      // console.log(menu,othersDropdown,othersMenu);

      if(!othersDropdown) {
        return false;
      }
  
      menu.classList.remove("fixed-height");
      othersDropdown.classList.remove("d-none");
   
      // Get only top-level li items that are NOT the othersDropdown
      const mainItems = Array.from(menu.querySelectorAll(':scope > li'))
        .filter(li => li !== othersDropdown);
   
      const dropdownItems = Array.from(othersMenu.children);
   
      // Step 1: Reset visibility
      // mainItems.forEach(item => item.style.display = '');
      // dropdownItems.forEach(item => item.style.display = 'none');
  
      // with class
      mainItems.forEach(item => item.classList.remove('d-none'));
      dropdownItems.forEach((item) => {
        item.classList.add('d-none');
        item.classList.remove('dropdown-visible');
      });
  
   
      // Step 2: Calculate available space
      const menuWidth = menu.offsetWidth;
      let usedWidth = othersDropdown.offsetWidth * 2;
   
      mainItems.forEach(item => {
        usedWidth += item.offsetWidth;
      });
   
      // Step 3: Hide from end until it fits
      for (let i = mainItems.length - 1; i >= 0 && usedWidth > menuWidth; i--) {
        const item = mainItems[i];
        usedWidth -= item.offsetWidth;
        // item.style.display = 'none';
        item.classList.add('d-none');
   
        const index = item.dataset.index;
        const matching = othersMenu.querySelector(`[data-index="${index}"]`);
        if (matching){
          matching.classList.remove('d-none');
          matching.classList.add('dropdown-visible');
        } 
        // matching.style.display = '';
      }
  
  
      const visibleDropdown = Array.from(othersMenu.children).filter((item) => {
        // console.log(item,"visibble-item");
        return item.classList.contains("dropdown-visible");
      })
  
      const visibleDropdownCount = visibleDropdown.length;
      let dropGrid = "";
  
      othersMenu.classList.remove("col-grid-2", "col-grid-3","col-grid-4");
  
      if (visibleDropdownCount > 10 && visibleDropdownCount < 11) {
        dropGrid = "col-grid-2";
      } else if (visibleDropdownCount > 20) {
        dropGrid = "col-grid-3";
      }
      else if (visibleDropdownCount > 30) {
        dropGrid = "col-grid-4";
      }
  
      // Apply new grid class if needed
      if (dropGrid) {
        othersMenu.classList.add(dropGrid);
      }
  
      // Step 4: Show/hide the othersDropdown
      const anyVisible = dropdownItems.some(item => !item.classList.contains('d-none'));
      othersDropdown.classList.toggle('d-none', !anyVisible);
    }
    

  }

  const openNav = function(){ 
    if (domWin) {
      domWin.querySelector("#mySidepanel").classList.add("active")
      domWin.querySelector("#mySidepanel").style.left = "0"; 
      domWin.querySelector("#outside").style.width = "100%";
    }
  } 

  const closeNav = function(){ 
    if(domWin) { 
      domWin.querySelector("#mySidepanel").classList.remove("active")
      domWin.querySelector("#mySidepanel").style.left = "-80%"; 
      domWin.querySelector("#outside").style.width = "0";
    }
  }
  
  let hamburger = <Elements data={data} row={data.elements.headerIcons} parentType="menu" id={"headerIcons"} device={device} classType="hamburger" mode={mode}/>;
  let headerSocialInfo = <Elements data={data} row={data.elements.headerSocialInfo} id={"headerSocialInfo"} device={device} mode={mode}/>;
  let logo = <Elements row={data.elements.logo} id={"logo"} device={device} mode={mode}/>;
  let primaryButton = <Elements data={data} row={data.elements.primaryButton} id={"primaryButton"} device={device} mode={mode}/>;
  // let secondaryButton = <Elements parent={loginValue} parentType="login" data={data} row={data.elements.secondaryButton} id={"secondaryButton"} device={device} mode={mode} />;
  let secondaryButton = loginValue;
  let pwaIcons = <Elements page={page} parentType="pwaIcons" data={data} row={data.elements.headerIcons} id={"headerIcons"} device={device} mode={mode} classType={app.iconsFilter(pages, "cart")} pages={pages} showLocationPopup={showLocationPopup} locationValue={locationValue} notificationValue={notificationValue} cartValue={cartValue} />;
  // let cart = <Elements page={page} parent={cartValue} parentType="cart" data={data} row={data.elements.headerIcons} id={"headerIcons"} device={device} mode={mode} classType={app.iconsFilter(pages, "cart")} />;
  // let notification = <Elements parent={notificationValue} parentType="notification" data={data} row={data.elements.headerIcons} id={"headerIcons"} device={device} mode={mode} />;
  // let location = <Elements parent={locationValue} parentType="location" className="popupAiWrapper" data={data} row={data.elements.headerIcons} id={"headerIcons"} device={device} mode={mode} showLocationPopup={showLocationPopup} classType={app.iconsFilter(pages, "location")} />;
  let navigation = <Elements data={data} row={data.elements.navigation} page={page} appData={props.appData} navigation={pages} id={"navigation"} device={device} mode={mode} showPopup={showPopup} />;
  let popUP = <MenuPopup data={data} home={pages} showPopup={showPopup} mode={mode} device={device}/>;
  let headerText = <Elements parent={headerValue} parentType="headerText" row={data.elements.headerText} id={"headerText"} classType="headerText" device={device} mode={mode}/>;
  let masterMenu =  <Elements data={data} row={data.elements.menu} id={"menu"} classType="menu" device={device} mode={mode}/>;
  
  
  // console.log("headerValue", headerValue, data.elements.headerText)
  
  let style = `
    #navigation li.on a{
        background:${app.getColor(data.elements.navigation.properties.backgroundClick)} !important;
        color:${app.getColor(data.elements.navigation.properties.textColorClick)} !important;
        border-color:${app.getColor(data.elements.navigation.properties.borderColorClick)} !important;
    } 
    #navigation li:hover a {
        background:${app.getColor(data.elements.navigation.properties.backgroundHover)} !important;
        color:${app.getColor(data.elements.navigation.properties.textColorHover)} !important;
        border-color:${app.getColor(data.elements.navigation.properties.borderColorHover)} !important;
    }

    #navigation li.dropdown .dropdown-menu {
      background:${app.getColor(data.elements.navigation.properties.submenuBackground)} !important;
    }

    [widget-type="headerAi"] .dropdown-style-grid {
        column-rule: 0.1px solid ${app.getColor(data.elements.navigation.properties.submenuTextColor)} !important;
    }

    #navigation li.dropdown .dropdown-menu li a.dropdown-item {
      background:${app.getColor(data.elements.navigation.properties.submenuBackground)} !important;
      color:${app.getColor(data.elements.navigation.properties.submenuTextColor)} !important;
    }

    #navigation li.dropdown .dropdown-menu li a.dropdown-item:hover{
      background:${app.getColor(data.elements.navigation.properties.submenuBackgroundHover)} !important;
      color:${app.getColor(data.elements.navigation.properties.submenuTextColorHover)} !important;
    }

    #morePagesbuilder input::placeholder {
      color: ${app.getColor(data.elements.navigation.properties.textColor)} !important;
    }
    .menuSearchBox::before,
    .location_box::before{background:${app.getColor(data.elements.navigation.properties.textColor)};opacity: .3;}
    .menuSearchBox input,
    .menuSearchBox span,
    #morePagesbuilder .all-category li,
    #morePagesbuilder .modal-title,
    #morePagesbuilder .btn-close,
    .popupAi li, .popupAi a,
    .popupAi .location_box *,
    .headerAiLogin *
    {color:${app.getColor(data.elements.navigation.properties.textColor)}  !important}
    .popupAi{
      background:${app.elementBackground(data.properties.backgroundWeb, data.properties.backgroundWebType, data.properties.overlayColorWeb)}
    }
    a.detect_location{
      color:${app.getColor(data.elements.primaryButton.properties.textColor)}  !important;
      background:${app.elementBackground(data.elements.primaryButton.properties.background, data.elements.primaryButton.properties.backgroundType, data.elements.primaryButton.properties.overlayColor)}
    }
    `

  let containerWidth = "container-fluid"
  if(mode === "live"){
    if(data.properties.isFluid === "container"){
      containerWidth = "container"
    }
  }

  //style={{background:app.elementBackground(data.properties.background, data.properties.backgroundType, data.properties.overlayColor)}}
  const slideStyle = app.elementBackground(data.properties.backgroundWeb, data.properties.backgroundWebType, data.properties.overlayColorWeb);
  const rootStyle = app.getStyle(data, device);
  rootStyle["background"] = slideStyle;
  let mobileHeader = <header data-mode={mode} headerstyle={data.properties.fixedHeaderStyle} className={app.getMode(mode)?`container-fluid position-relative headerAi mobileHeaderAi ${app.getClass(data, device)}`:`container-fluid position-relative mobileHeaderAi headerAi`} style={app.getMode(mode)?app.getStyle(data, device):null} widget-type={data.widgetType}>
  <nav className="ai-navbar">
      <div className={mode === "edit"?`navbar-brand site-logo d-none`:`navbar-brand site-logo`}>
         {logo}
      </div>  
      <div className='text-center' style={{position: "absolute",left: '50%', transform: 'translateX(-50%)'}}>{headerText}</div>
      <div className='d-flex ms-auto'> 
      <button id="openbtn" onClick={mode === "live"?()=>openNav():null}>{hamburger}</button>
      </div>
 </nav>

 <div id="mySidepanel" className="sidepanel" style={{background:slideStyle}}>
     <a className="closebtn icon-right-open" onClick={()=>closeNav()}></a>
     <div className='d-flex cart_notification'> 
         {/* {cart} */}
         {secondaryButton}
         {/* {notification} */}
         {/* {location}  */}
     </div> 
     <div className="input-group mb-3">
        <input type="text" className="form-control" onChange={searchMobileMenu} placeholder={app.getLang("searchHere")} style={{height:'46px', border:'0px', background:'rgba(0, 0, 0, 0.07)', boxShadow:'none'}}/>
        <span className="input-group-text icon-search-3" style={{height:'46px', border:'0px', background:'rgba(0, 0, 0, 0.07)', boxShadow:'none', cursor: 'pointer', color:app.getColor(data.elements.navigation.properties.textColor)}}></span>
     </div>
     
     {navigation}
     {headerSocialInfo}
     {primaryButton} 
 </div>
 <div id='outside' onClick={()=>closeNav()} style={{background: '#000000bd'}}></div>
  
</header> 

// if(!headerHeight){
//   return 'Loading'
// }
 
  if(device === "desktop"){ 
    if(data.properties.headerLayout === "1"){ 
      return <React.Fragment><header suppressHydrationWarning headerstyle={data.properties.fixedHeaderStyle} data-mode={mode} className={app.getMode(mode)?`position-relative headerAi ${app.getClass(data, device)}`:`position-relative headerAi`} header-type={data.properties.headerLayout} style={app.getMode(mode)?app.getStyle(data, device):null} widget-type={data.widgetType}>
              <style jsx global>{`${style}`}</style>
              <div className={containerWidth} style={{paddingTop:data.properties.height+'vw', paddingBottom:data.properties.height+'vw'}}>
                  <nav className="ai-navbar d-flex w-100"> 
                      <div className={`navbar-brand site-logo`}>
                          {logo}
                      </div>
                     
                      <div className='d-flex ms-auto align-items-center w-100 justify-content-end'>
                      <nav className="ai-navbar w-100 justify-content-end" menu-type={data.elements.navigation.layoutType}>
                          {navigation}
                      </nav>
                        {headerSocialInfo} 
                        {primaryButton} 
                        {/* {cart}
                        {notification}
                        {location} */}
                        {secondaryButton}
                        {pwaIcons}
                      </div> 
                  </nav>
                  
              </div> 
              {masterMenu}
          </header>  
          {popUP}
          {mobileHeader}
          </React.Fragment>
    }
    else if(data.properties.headerLayout === "2"){ 
      return <React.Fragment><header suppressHydrationWarning headerstyle={data.properties.fixedHeaderStyle} data-mode={mode} className={app.getMode(mode)?`position-relative headerAi ${app.getClass(data, device)}`:`position-relative headerAi`} header-type={data.properties.headerLayout} style={app.getMode(mode)?app.getStyle(data, device):null} widget-type={data.widgetType}>
   <style jsx global>{`${style}`}</style>
              <div className={containerWidth} style={{paddingTop:data.properties.height+'vw', paddingBottom:data.properties.height+'vw'}}>
                  <nav className="ai-navbar">
                      {headerSocialInfo}
                      
                      <div className={`navbar-brand site-logo`} style={{transform:`translateX(calc(-50% - ${socialWidth}px))`}}>
                          {logo}
                      </div>
                      <div className='d-flex ms-auto'>
                      {/* <div className={`${app.isButton(data.elements.primaryButton, device)} ${app.isButton(data.elements.secondaryButton, device)}`}> */}
                          {primaryButton}
                         
                      {/* </div> */}
                      {/* {cart}
                      {notification}
                      {location} */}
                      {secondaryButton}
                      {pwaIcons}
                      </div> 
                  </nav>
                  <nav className="ai-navbar" menu-type={data.elements.navigation.layoutType}>
                      {navigation}
                  </nav>
              </div>
              {masterMenu}
          </header> 
          {popUP} 
          {mobileHeader}
          </React.Fragment>
    }
    else if(data.properties.headerLayout === "3"){ 
      return <React.Fragment>
      <header suppressHydrationWarning data-mode={mode} headerStyle={data.properties.fixedHeaderStyle} className={app.getMode(mode)?`position-relative headerAi ${app.getClass(data, device)}`:`position-relative headerAi`} header-type={data.properties.headerLayout} style={app.getMode(mode)?app.getStyle(data, device):null} widget-type={data.widgetType}>
      <style jsx global>{`${style}`}</style>
          <div className={containerWidth} style={{paddingTop:data.properties.height+'vw', paddingBottom:data.properties.height+'vw'}}>
              <nav className="ai-navbar">
                 <div className={`navbar-brand site-logo`}>
                      {logo}
                  </div>
                 <div className='d-flex ms-auto'>
                      {headerSocialInfo}
                      {primaryButton} 
                      {/* {cart} 
                      {notification}
                      {location} */}
                      {secondaryButton} 
                      {pwaIcons}
                  </div> 
              </nav>
              <nav className="ai-navbar" menu-type={data.elements.navigation.layoutType}>
                  {navigation}
              </nav>
          </div>
          {masterMenu}
      </header> 
      {popUP}
      {mobileHeader}
      </React.Fragment>
    }
  }
  else{
    return mobileHeader 
  }
  

}
export default HeaderAi;